import { useContext } from "react";
import { UploadCsvContext } from "../../context/Faltantes/UploadCsvContext";

export function useUploadCsvSteps() {
  const context = useContext(UploadCsvContext);

  if (!context) {
    throw new Error("useUploadCsvSteps must be used within an UploadCsvStepsProvider");
  }

  return context;
}
